import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guide-o365-powershell',
  templateUrl: './guide-o365-powershell.component.html',
  styleUrls: ['./guide-o365-powershell.component.scss']
})
export class GuideO365PowershellComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
